<template>
  <div>

  </div>
</template>

<script>

  export default{

    data(){
      return{

      }
    },

    methods:{
      configData(){
        var str = this.$route.params.res
        console.log(this.$api)
        var json = this.$api.decrypt(str)

        this.$api.set_user_id(json.user_id)
        this.$api.set_user_token(json.user_token)

        // if (localStorage.getItem('old_customer')) {

        var _this = this
        var params = {
          user_id : this.$api.user_id(),
          user_token : this.$api.user_token(),
        }
        this.$api.post("cc_user_query", params,function (res) {
          // 请求成功
          if (res.code == 0) {
            if (res.data.phone.length ==0) {
              // _this.$router.replace({name: 'binding',query:{from:"login"}})
              // window.location.replace = window.location.origin + '/cmlink/#/binding?from=login';
              window.location.replace(window.location.origin + '/'+ json.from +'/#/binding?from=login&page=' + json.page)
            } else {
              // _this.$router.replace({name: json.page})

              // window.location.replace = window.location.origin + '/cmlink/#/' + json.page;
              window.location.replace(window.location.origin + '/'+ json.from +'/#/' + json.page)
            }

          } else {

          }
        }, function (err) {
          // 请求失败

        },);
      }
    },

    mounted() {

      this.$nextTick(function () {
        this.configData()
      })





      // } else {
      //   localStorage.setItem('old_customer','yes')
      //   this.$router.replace({name: json.page})
      // }


    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/PopSpecifiedPage.vue